import "../../components/generalComponents.scss";

import { Admin, listAdminByLevels } from "../../services/admin.service";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Button from "../../components/buttons/Button";
import Dashboard from "../dashboard/Dashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StudentReportDetails from "./StudentReportDetails";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import fetchWithToken from "../../utils/fetchWithToken";
import formatDate from "../../utils/date.formater";
import reportStyle from "./reports.module.scss";
import showToast from "../../utils/show.toast";
import style from "../../pages/reviews/review.module.scss";

interface IAdminList {
  isLoading: boolean;
  adminList: Admin[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

interface Attachment {
  name: string;
  url: string;
}

export interface IReport {
  id: number;
  studentName: string;
  teacherName: string;
  email: string;
  date: string;
  category: string;
  status: string;
  message: string;
  attachments: Attachment[];
}

export default function StudentReportList() {
  const [selectedReport, setSelectedReport] = useState<IReport | null>(null);
  const [reports, setReports] = useState<IReport[]>([]);

  useEffect(() => {
    const fetchReports = async () => {
      const res = await fetchWithToken(`/reports/students`);
      const data = await res.json();

      setReports(data.result);
    };

    fetchReports();
  }, []);

  const handleViewReport = (report: IReport) => {
    setSelectedReport(report);
  };

  const handleBack = () => {
    setSelectedReport(null);
  };

  const handleAction = (actionType: any) => {
    console.log(`Action taken: ${actionType}`);
    showToast(`Report ${actionType}`, true);
    setSelectedReport(null);
    return;
  };

  return (
    <Dashboard pageTitle={selectedReport ? "Report Details" : "Reports List"}>
      {!selectedReport ? (
        <div className={style.languagePage}>
          <div className={style.pageTable}>
            {reports.length === 0 ? (
              <p
                className={style.textStyle}
                style={{ marginTop: "2px", marginBottom: "3px" }}
              >
                No reports available yet
              </p>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginBottom: "1rem",
                  }}
                ></div>
                <table>
                  <>
                    <thead>
                      <tr>
                        <th>Student Name</th>
                        <th>Teacheer Name</th>
                        <th>Report Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ cursor: "pointer" }}>
                      {reports.map((report) => (
                        <tr key={report.id}>
                          <td>{report.studentName}</td>
                          <td>{report.teacherName}</td>
                          <td>{report.date}</td>
                          <td>
                            <button
                              className={reportStyle.generalbtn}
                              onClick={() => handleViewReport(report)}
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </>
                </table>
              </>
            )}
          </div>
        </div>
      ) : (
        <StudentReportDetails
          report={selectedReport}
          onBack={handleBack}
          onAction={handleAction}
        />
      )}
    </Dashboard>
  );
}
